import { ApiMutationConfig, ApiQueryConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';
import { RunningSequence, RunningService } from './types';

type CloudServicePathParams = { $cloudServiceId: number };
type GetCloudServiceRunningServicesConfig = ApiQueryConfig<
  RunningService[],
  CloudServicePathParams
>;
type GetCloudServiceRunningSequencesConfig = ApiQueryConfig<
  RunningSequence[],
  CloudServicePathParams
>;
type PostPauseCloudServiceConfig = ApiMutationConfig<
  unknown,
  CloudServicePathParams
>;
type PostUnpauseCloudServiceConfig = ApiMutationConfig<
  unknown,
  CloudServicePathParams
>;

const url = `${URLS.app}/api/CloudServices/$cloudServiceId`;

export const getRunningServices =
  createApiEndpoint<GetCloudServiceRunningServicesConfig>({
    method: 'GET',
    url: `${url}/RunningServices`,
  });

export const getRunningSequences =
  createApiEndpoint<GetCloudServiceRunningSequencesConfig>({
    method: 'GET',
    url: `${url}/RunningSequences`,
  });

export const pauseCloudService = createApiEndpoint<PostPauseCloudServiceConfig>(
  {
    method: 'POST',
    url: `${url}/Pause`,
  },
);

export const unpauseCloudService =
  createApiEndpoint<PostUnpauseCloudServiceConfig>({
    method: 'POST',
    url: `${url}/Unpause`,
  });
